import React, { Component } from 'react';
import api from 'api';
import { Button, Text, Box } from 'components';

export default class LockedTerms extends Component {
  state = {
    terms: null,
    accept_terms: false
  };

  componentDidMount() {
    api.get(`onboarding/locked_tokens_terms`).then(res => {
      this.setState({ terms: res.data });
    });
  }
  j;
  handleChange = e => {
    this.setState({ accept_terms: e.target.checked });
  };

  render() {
    const { terms, accept_terms } = this.state;

    const disabled = !accept_terms;

    return (
      <div className="terms-overlay">
        <div className="terms-modal">
          <Text display="h2" className="py-4">
            {terms && terms.messaging.title}
          </Text>
          <div className="row">
            <div className="col-md-4 position-relative">
              <div className="sticky">
                <Text>
                  Please read the terms provided and check the box to
                  acknowledge your consent.
                </Text>
                <Text>
                  If there are any issues with your details, please contact us
                  at <a href="mailto:ops@current.us">ops@current.us</a>
                </Text>
              </div>
            </div>
            <div className="col-md terms-description">
              <div
                dangerouslySetInnerHTML={{
                  __html: terms && terms.messaging.description
                }}
              />
            </div>
          </div>
          <Box className="terms-footer terms">
            <div className="container">
              <div className="row">
                <div className="col-md d-flex">
                  <input
                    className="mt-1"
                    type="checkbox"
                    id="accept_locked_terms"
                    name="accept_locked_terms"
                    onChange={this.handleChange}
                  />
                  <label className="ml-3" htmlFor="accept_locked_terms">
                    {terms && terms.messaging.accept_terms}
                  </label>
                </div>
                <div className="col-md text-right">
                  <div className="d-inline-block">
                    <Button
                      secondary
                      large
                      disabled={disabled}
                      onClick={this.props.onAccept}
                    >
                      Continue
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </Box>
        </div>
      </div>
    );
  }
}
